import { Deposit } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomHeaderText,
  CustomDateColumn,
  DepositAmountColumn,
  DepositsActionColumn,
  DepositsStatusColumn,
  DepositReferenceColumn,
  DepositMovileViewColumn,
} from 'src/components'


const depositsListColumns: ColumnsType<Deposit> = [
  {
    title: () => <CustomHeaderText text='Deposits.Status' />,
    responsive: ['sm'],
    dataIndex: 'status',
    render: (_, deposit) => {
      return <DepositsStatusColumn deposit={deposit} />
    }
  },
  {
    title: () => <CustomHeaderText text='Deposits.Reference' />,
    responsive: ['sm'],
    dataIndex: 'internal_reference',
    render: (_, deposit) => {
      return <DepositReferenceColumn deposit={deposit} />
    }
  },
  {
    title: () => <CustomHeaderText text='Deposits.Total' />,
    responsive: ['sm'],
    dataIndex: 'total',
    sorter: (a: Deposit, b: Deposit) => {
      return a.total - b.total
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, deposit) => {
      return <DepositAmountColumn deposit={deposit} />
    }
  },
  {
    title: () => <CustomHeaderText text='Deposits.Date' isCentered />,
    responsive: ['sm'],
    dataIndex: 'created',
    sorter: (a: Deposit, b: Deposit) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, deposit) => {
      return <CustomDateColumn dateValue={deposit.created} />
    }
  },

  {
    title: () => <CustomHeaderText text='Deposits.Actions' isCentered />,
    dataIndex: 'status',
    responsive: ['sm'],
    render: (_, deposit) => {
      return <DepositsActionColumn deposit={deposit} />
    }
  },

  // Mobile
  {
    title: () => <CustomHeaderText text={'Summary.Deposit'} />,
    responsive: ['xs'],
    sorter: (a: Deposit, b: Deposit) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <DepositMovileViewColumn deposit={record} />
  }
]

export default depositsListColumns
